export default function (now: Date) {
  const h = now.getHours();
  if (h >= 0 && h < 12) return "Buenos días";
  if (h >= 12 && h < 18) return "Buenas tardes";
  return "Buenas noches";
}
